import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/fromEvent';
import * as _ from 'lodash';
import { AddUserComponent } from 'src/app/components/users/add-user/add-user.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DeleteUserComponent } from '../delete-user/delete-user.component';
import { DeleteAffiliatedUserComponent } from '../delete-affiliated-user/delete-affiliated-user.component';
import { UpdateAffiliatedUserComponent } from '../update-affiliated-user/update-affiliated-user.component';
import { AddSupplierUserComponent } from '../add-supplier-user/add-supplier-user.component';
import { AddCustomerUserComponent } from '../add-customer-user/add-customer-user.component';
import { Event, NavigationStart } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';


@Component({
  selector: 'hg-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit, OnDestroy {

  constructor(private authHttp: HttpClient,
    private route: ActivatedRoute,
    private _router: Router,
    private _gaSvc: GoogleAnalyticsService,
    private flashMessageService: FlashMessageService,
    public currentUserService: CurrentUserService,
    private modal: ModalService
  ) {
    // Subscribe to router event and reset page number to 1 everytime the URL is changed
    this.routerEventsubscription = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.up = 1;
      }
    });
  }

  //public type: string;
  public title: 'Users';

  private filter: string;
  public filterSearch: string;
  private sub: any;
  public users: any[] = [];
  public user: any;
  public filteredHeader: string;
  public promptDeleteUser: boolean = false;
  public loading: boolean = false;
  public userUrl = environment.runtime.userManagementApiUrl;
  public type: string = 'customer';
  public usersFilterProperty: string = '';
  public usersFilterDirection: string = 'asc';
  public addUser: boolean = false;
  public up: number = 1;
  public totalUsers: number = 0;

  public entitlements = [];
  public role: string;
  public showAddNewUserButton: boolean = true;
  private routerEventsubscription: any;

  // public users;

  onRedirectHandler($event) {

  }

  onBackEventHandler() { }

  ngOnInit() {
    this.currentUserService.getUser().then(user => {
      this.loading = true;
      this.setupInitFilter();
      this.setupQuickSearch();
      let entitlementObs = _.get(this.currentUserService.user, 'role.entitlements', []);

      this.entitlements = entitlementObs.map(entitlemtnt => entitlemtnt.code).reduce((a, b) => (a[b] = true, a), {});
      this.role = _.get(this.currentUserService.user, 'role.code', '');

      this.sub = this.route.params.subscribe(params => {
        this.filter = params['filter'];
        // hide add new user button for FACTORING COMPANY tab.
        this.showAddNewUserButton = this.filter === 'hc_cr_factoring' ? false: true;
        this.grabNextPage();
      });
    });

  }

  ngOnDestroy(): void {
    this.routerEventsubscription.unsubscribe();
  }

  public showMassUpload: boolean = false;
  public btnOptions: any[] = [{ value: 'mass-upload', label: 'Mass Upload' }];
  /**
   * Perform actions based on button clicked
   * btn-add --> Open Add supplier button
   * show-options, mass-upload --> Set showMassUpload
   * @param $event { event.value } => btn-add/show-options/mass-upload
   */
  public optionClicked($event: any): void {
    switch($event) {
      case "customer":
        this.modal.open(AddCustomerUserComponent);
        break;
      case "supplier":
        this.modal.open(AddSupplierUserComponent);
        break;
      case "carrier":
        this._router.navigateByUrl('/add-carrier-user');
        break;
      case "factoring":
        this._router.navigate(['/add-carrier-user'], {queryParams: {requestType: RequestAccessTypesEnum.FACTORING_COMPANY}})
        break;
      case "mass-upload":
        this._router.navigateByUrl('users-mass-upload');
        break;
    }
  }

  /**
   * Hide mass upload dropdown on click away from the button area
   */
  public clickingAway() {
    this.showMassUpload = false;
  }

  private getFilteredHeader() {
    if (this.filter) {
      switch (this.filter.toUpperCase()) {
        case 'ALL':
          this.filter = null;
          this.filteredHeader = "";
          break;
        case 'HC_INTERNAL':
          this.filteredHeader = "Internal Admin ";
          break;
        case 'HC_CUSTOMER':
          this.filteredHeader = "Customer ";
          break;
        case 'HC_SUPPLIER':
          this.filteredHeader = "Supplier ";
          break;
        case 'HC_CARRIER':
          this.filteredHeader = "Carrier ";
          break;
        case 'HC_INTERNAL_ADMIN':
          this.filteredHeader = "Internal Hub Admin ";
          break;
        case 'HC_INTERNAL_SUPPLIER_ADMIN':
          this.filteredHeader = "Internal Supplier Admin ";
          break;
        case 'HC_INTERNAL_CARRIER_ADMIN':
          this.filteredHeader = "Internal Carrier Admin ";
          break;
        case 'HC_CUSTOMER_ADMIN':
          this.filteredHeader = "Customer Admin ";
          break;
        case 'HC_CUSTOMER_USER':
          this.filteredHeader = "Customer ";
          break;
        case 'HC_CUSTOMER_ADHOC':
          this.filteredHeader = "Custom ";
          break;
        case 'HC_CUSTOMER_CLAIMS_USER':
          this.filteredHeader = "Claims ";
          break;
        case 'HC_CUSTOMER_LOGISTICS_ADMIN':
          this.filteredHeader = "Logistics Admin ";
          break;
        case 'HC_CUSTOMER_LOGISTICS_USER':
          this.filteredHeader = "Logistics Customer ";
          break;
        case 'HC_SUPPLIER_ADMIN':
          this.filteredHeader = "Supplier Admin ";
          break;
        case 'HC_SUPPLIER_USER':
          this.filteredHeader = "Supplier ";
          break;
        case 'HC_CARRIER_ADMIN':
          this.filteredHeader = "Carrier Admin - I ";
          break;
        case 'HC_CARRIER_ACCOUNTING':
          this.filteredHeader = "Carrier Accounting ";
          break;
        case 'HC_CARRIER_DISPATCHER':
          this.filteredHeader = "Carrier Dispatcher ";
          break;
        case 'HC_CARRIER_BROKER_ADMIN':
          this.filteredHeader = "Carrier Admin - II ";
          break;
        case 'HC_CARRIER_BROKER_USER':
          this.filteredHeader = "Carrier Broker ";
          break;
      }
    }
  }

  getOrganizationName(user) {
    if (this.isAffiliatedUser(user) && this.currentUserService.user.organizationCode !== 'HUBG') {
      let organizations = user.extended.organizations.find(org => org.organizationCode === this.currentUserService.user.organizationCode);
      return organizations.organizationName;
    }
    return user.organizationName;
  }

  userRole(user) {
    let application = { roleCode: '' };
    if (user.applications && user.applications.length) {
      application = user.applications.find(app => {
        if (app.organizationCode && this.currentUserService.user.organizationCode !== 'HUBG') {
          return app.clientName === 'HubConnect' && app.organizationCode === this.currentUserService.user.organizationCode;
        } else {
          return app.clientName === 'HubConnect';
        }
      });
    }
    if (application) {
      switch (application.roleCode) {
        case 'HC_CUSTOMER_ADMIN':
          return 'Customer Admin';
        case 'HC_CUSTOMER_USER':
          return 'Customer User';
        case 'HC_CUSTOMER_CLAIMS_USER':
          return 'Claims User';
        case 'HC_CUSTOMER_ADHOC':
          return 'Custom User';
        case 'HC_HUB_INTERNAL_ADMIN':
        case 'HC_INTERNAL_ADMIN':
          return 'Hub Admin';
        case 'HC_CUSTOMER_LOGISTICS_ADMIN':
          return 'Logistics Admin';
        case 'HC_CUSTOMER_LOGISTICS_USER':
          return 'Logistics User';
        case 'HC_SUPPLIER_ADMIN':
          return 'Supplier Admin';
        case 'HC_SUPPLIER_USER':
          return 'Supplier User';
        case 'HC_INTERNAL_SUPPLIER_ADMIN':
          return 'Hub Supplier Admin';
        case 'HC_INTERNAL_CARRIER_ADMIN':
          return 'Hub Carrier Admin';
        case 'HC_CARRIER_ADMIN':
          return 'Carrier Admin - I';
        case 'HC_CARRIER_ACCOUNTING':
          return 'Carrier Accounting';
        case 'HC_CARRIER_DISPATCHER':
          return 'Carrier Dispatcher';
        case 'HC_CR_FACTORING_ADMIN':
          return 'Factoring Admin';
        case 'HC_CARRIER_BROKER_ADMIN':
          return 'Carrier Admin - II';
        case 'HC_CARRIER_BROKER_USER':
          return 'Carrier Broker';
      }
    }
  }

  public checkAddCustomerPrivilege() {
    return this.entitlements['HC_CUSTOMER_CREATE_USER'] && (!this.entitlements['HC_CR_CREATE_USER'] && !this.entitlements['HC_SUPPLIER_CREATE_USER']);
  }

  public checkAddSupplierPrivilege() {
    return this.entitlements['HC_SUPPLIER_CREATE_USER'] && (!this.entitlements['HC_CUSTOMER_CREATE_USER'] && !this.entitlements['HC_CR_CREATE_USER'])
  }

  public checkAddCarrierPrivilege() {
    return this.entitlements['HC_CR_CREATE_USER'] && (!this.entitlements['HC_CUSTOMER_CREATE_USER'] && !this.entitlements['HC_SUPPLIER_CREATE_USER'])
  }

  public isAffiliatedUser(user) {
    return user.extended.organizations && user.extended.organizations.length > 1;
  }

  checkRole(role) {
    return this.role === role;
  }

  isInternalCarrirAdmin() {
    return ['HC_INTERNAL_CARRIER_ADMIN', 'HC_INTERNAL_ADMIN'].includes(this.role);
  }

  public checkType(user) {
    let roleType = _.get(user, "applications[0].roleCode", '').toLowerCase();
    if (roleType.includes('supplier')) {
      return 'supplier';
    }
    else if (roleType.includes('customer')) {
      return 'customer'
    }
    else if (roleType.includes('carrier')) {
      return 'carrier'
    }
    else if (roleType.includes('hc_cr_factoring')) {
      return 'factoring company'
    }
    else {
      return '';
    }
  }

  public resetUserPassword(user) {
    this.loading = true;
    this.currentUserService.resetPassword(user.email)
      .then(resp => {
        this.loading = false;
        this.flashMessageService.updateMessage("Password reset email sent.", 3000, "success");
        this._gaSvc.register(`Admin reset the password`, user.organizationName);
      })
      .catch(error => {
        this.loading = false;
        let message = "";
        if (error.status == 500) {
          message = "Internal server error while loading requests"
        } else {
          message = error.message.json();
        }
        this.flashMessageService.updateMessage(message);
      })
  }

  public removeUser(user) {
    this.users = this.users.filter(item => item !== user);
    this.totalUsers--;
  }

  public patchUser(user) {
    this.users = this.users.filter(item => item !== user);
  }

  public getQueryParams(user) {
    let queryParams = {
      ID: user._id
    }

    switch (this.checkType(user)) {
      case 'customer':
        queryParams['customerID'] = user.organizationCode;
        break;
      case 'supplier':
        queryParams['supplierID'] = user.organizationCode;
        break;
      case 'carrier':
        queryParams['carrierID'] = user.organizationCode;
        break;
      case 'factoring company':
        queryParams['facCompanyID'] = user.organizationCode;
        break;
    }
    return queryParams;
  }

  public getdetailUrl(user) {
    switch (this.checkType(user)) {
      case 'customer':
        return '../../update-customer-user';
      case 'supplier':
        return '../../update-supplier-user';
      case 'carrier':
        return '../../update-carrier-user';
      case 'factoring company':
        return '../../update-carrier-user';
    }
  }

  public checkViewPrivilege(user) {
    switch (this.checkType(user)) {
      case 'customer':
        if (
          this.currentUserService.entitlements['HC_CUSTOMER_UPDATE_USER'] ||
          this.currentUserService.entitlements['HC_CUSTOMER_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_UPDATE_USER']
        )
          return true;
        return false;
      case 'supplier':
        if (
          this.currentUserService.entitlements['HC_SUPPLIER_UPDATE_USER'] ||
          this.currentUserService.entitlements['HC_SUPPLIER_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_UPDATE_USER']
        )
          return true;
        return false;
      case 'carrier':
        if (
          this.currentUserService.entitlements['HC_CR_UPDATE_USER'] ||
          this.currentUserService.entitlements['HC_CR_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_UPDATE_USER']
        )
          return true;
        return false;
      case 'factoring company':
        if (
          this.currentUserService.entitlements['HC_CR_UPDATE_USER'] ||
          this.currentUserService.entitlements['HC_CR_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_VIEW_USER'] ||
          this.currentUserService.entitlements['HC_INTERNAL_UPDATE_USER']
        )
          return true;
        return false;
    }
  }

  public checkDeletePrivilege(user) {
    switch (this.checkType(user)) {
      case 'customer':
        return (
          this.currentUserService.entitlements.indexOf('HC_CUSTOMER_DELETE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_DELETE_USER') > -1
        )
        return true;
        return false;
      case 'supplier':
        if (
          this.currentUserService.entitlements.indexOf('HC_SUPPLIER_DELETE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_DELETE_USER') > -1
        )
          return true;
        return false;
      case 'carrier':
        if (
          this.currentUserService.entitlements.indexOf('HC_CR_DELETE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_DELETE_USER') > -1
        )
          return true;
        return false;
      case 'factoring company':
        if (
          this.currentUserService.entitlements.indexOf('HC_CR_DELETE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_DELETE_USER') > -1
        )
          return true;
        return false;
    }
  }

  public checkResetPasswordPrivilege(user) {
    switch (this.checkType(user)) {
      case 'customer':
        return (
          this.currentUserService.entitlements.indexOf('HC_CUSTOMER_UPDATE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_UPDATE_USER') > -1
        );

      case 'supplier':
        return (
          this.currentUserService.entitlements.indexOf('HC_SUPPLIER_UPDATE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_UPDATE_USER') > -1
        );

      case 'carrier':
        return (
          this.currentUserService.entitlements.indexOf('HC_CR_UPDATE_USER') > -1 ||
          this.currentUserService.entitlements.indexOf('HC_INTERNAL_UPDATE_USER') > -1
        );
    }
  }

  sortAsc(property: string) {
    let isSameProperty: boolean = property === this.usersFilterProperty;
    let isSameDirection: boolean = this.usersFilterDirection === 'asc';
    if ((isSameProperty && !isSameDirection) || !isSameProperty) {
      this.usersFilterDirection = 'asc';
      this.usersFilterProperty = property;
      this.grabNextPage();
    }
  }

  sortDesc(property: string) {
    let isSameProperty: boolean = property === this.usersFilterProperty;
    let isSameDirection: boolean = this.usersFilterDirection === 'desc';
    if ((isSameProperty && !isSameDirection) || !isSameProperty) {
      this.usersFilterDirection = 'desc';
      this.usersFilterProperty = property;
      this.grabNextPage();
    }
  }

  public grabNextPage() {
    this.users = [];
    this.totalUsers = 0;
    this.loading = true;
    var url = `${this.userUrl}/user/getUsers?page=${this.up}`;
    this.getFilteredHeader();
    if (this.filter) {
      url = url + `&filter=${this.filter}`;
    }
    const quickSearchElement = document.getElementById('quicksearch');
    const quickSearch = _.get(quickSearchElement, 'value', '').trim();

    if (quickSearch) {
      url = `${url}&quickSearch=${quickSearch}`
    }

    if (this.usersFilterProperty) {
      url = url + `&filterHeader=${this.usersFilterProperty} ${this.usersFilterDirection}`;
    }
    this.saveFilter({ page: this.up, quickSearch, filter: this.filter, filterHeader: `${this.usersFilterProperty} ${this.usersFilterDirection}` });
    this.authHttp.get(url).toPromise()
      .then((response: any) => {
        if (response.users) {
          this.users = response.users;
          this.totalUsers = response.count;
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        this.flashMessageService.updateMessage(`Error loading Users`);
      });
  }

  setupInitFilter() {
    const stateFilter = localStorage.getItem('userListFilter');
    if (stateFilter) {
      try {
        const filter = JSON.parse(stateFilter);
        this.up = filter.page;
        const quickSearch = filter.quickSearch;
        const quickSearchElement = document.getElementById('quicksearch') || document.getElementById('quicksearchSmall');
        quickSearchElement.setAttribute('value', quickSearch);
        this.filter = filter.filter;
        const [direction, ..._property] = filter.filterHeader.split(' ').reverse();
        this.usersFilterProperty = _property.join(' ');
        this.usersFilterDirection = direction; 
      } catch (error) {
        console.error('Error parsing user list filter from local storage', error);
      }
    }
  }

  saveFilter({ page, quickSearch, filter, filterHeader }) {
    // take search and other filters from the url and store it in the state when it comes to this page again automatically populate the search and filters
    const state = {
      page,
      quickSearch,
      filter,
      filterHeader
    };
    localStorage.setItem('userListFilter', JSON.stringify(state));
  }

  switchMapHandler(quickSearchElement) {
    this.loading = true;
    this.up = 1;
    const quickSearch = _.get(quickSearchElement, 'value', '').trim();
    var url = `${this.userUrl}/user/getUsers?page=${this.up}&quickSearch=${quickSearch}`;
    this._gaSvc.register(`User Admin`, `Search Users`, quickSearch);
    if (this.filter) {
      url = url + `&filter=${this.filter}`;
    }
    if (this.usersFilterProperty) {
      url = url + `&filterHeader=${this.usersFilterProperty} ${this.usersFilterDirection}`;
    }
    this.saveFilter({ page: this.up, quickSearch, filter: this.filter, filterHeader: `${this.usersFilterProperty} ${this.usersFilterDirection}` });
    return this.authHttp.get(url);
  }

  private setupQuickSearch() {
    Observable.fromEvent(document.getElementById('quicksearch'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(750),
      distinctUntilChanged(),
      switchMap(() => this.switchMapHandler(document.getElementById('quicksearch')))
    ).subscribe((data: any) => {
      this.users = data.users;
      this.totalUsers = data.count;
      this.loading = false;
    });

    Observable.fromEvent(document.getElementById('quicksearchSmall'), 'input').pipe(
      map((e: KeyboardEvent) => {
        let element = e.target as HTMLInputElement;
        let value = element.value;
        return value;
      }),
      debounceTime(750),
      distinctUntilChanged(),
      switchMap(() => this.switchMapHandler(document.getElementById('quicksearchSmall')))
    ).subscribe((data: any) => {
      this.users = data.users;
      this.totalUsers = data.count;
      this.loading = false;
    });
  }

  sortList(property: string, reverse: boolean = false) {
    this.usersFilterProperty = property;
    let array = this.users.slice();
    array.sort((a: any, b: any) => {
      if (property === 'employeeID') { // will want to refactor this sorting code to be more flexible
        if (!a.extended.employeeID)     // maybe even rework the user object to never have missing objects
          a.extended.employeeID = '';
        if (!b.extended.employeeID)
          b.extended.employeeID = '';
        var sorting = a.extended.employeeID.toUpperCase() > b.extended.employeeID.toUpperCase() ? 1 : -1;
        if (a.extended.employeeID.toUpperCase() === b.extended.employeeID.toUpperCase())
          sorting = 0;
        return sorting;
      }
      else if (property === 'roleCode') {
        var sorting = a.applications[0].roleCode.toUpperCase() > b.applications[0].roleCode.toUpperCase() ? 1 : -1;
        if (a.applications[0].roleCode.toUpperCase() === b.applications[0].roleCode.toUpperCase())
          sorting = 0;
        return sorting;
      }
      else if (property === 'organizationName') {
        var sorting = a[property] > b[property] ? 1 : -1;
        if (a[property] === b[property])
          sorting = 0;
        return sorting;
      }
      else {
        var sorting = a[property].toUpperCase() > b[property].toUpperCase() ? 1 : -1;
        if (a[property].toUpperCase() === b[property].toUpperCase())
          sorting = 0;
        return sorting;
      }
    });
    if (reverse) {
      this.usersFilterDirection = 'desc';
      return array.reverse();
    } else {
      this.usersFilterDirection = 'asc';
      return array
    }
  }

  public async openModal(type, data = null) {
    const user = await this.currentUserService.user;
    if (type === 'addUser') {
      this._gaSvc.register(`User Admin`, `Add New User Button`, user.username);
      this.modal.open(AddUserComponent)
    } else if (type === 'deleteUser') {
      if (this.currentUserService.isImpersonator) {
        return;
      }

      this.user = data;
      let subscription = this.modal.closeEvent.subscribe((data) => {
        if (data) {
          this.removeUser(data);
        }
        this.user = null;
        subscription.unsubscribe();
      })
      this._gaSvc.register(`User Admin`, `Delete User Button`, user.username);
      this.modal.open(DeleteUserComponent, this.user)
    } else if (type === 'editAffiliatedUser') {
      this.user = data;
      if (user.organizationCode !== 'HUBG') {
        this.navigateUpdateAffiliatedCarrier(this.user, user.organizationCode);
      } else {
        let subscription = this.modal.closeEvent.subscribe((data) => {
          if (data) {
            this.navigateUpdateAffiliatedCarrier(this.user, data);
          }
          this.user = null;
          subscription.unsubscribe();
        })
        this.modal.open(UpdateAffiliatedUserComponent, { 'user': data, 'code': user.organizationCode })
      }
      this._gaSvc.register(`User Admin`, `Edit Affiliated User Button`, user.username);
    } else if (type === 'deleteAffiliatedUser') {
      this.user = data;
      let subscription = this.modal.closeEvent.subscribe((data) => {
        if (data) {
          this.removeUser(data);
        }
        this.user = null; 
        subscription.unsubscribe();
      })
      this._gaSvc.register(`User Admin`, `Delete Affiliated User Button`, user.username);
      this.modal.open(DeleteAffiliatedUserComponent, {'user': data, 'code': user.organizationCode})
    } else if (type === "add-supplier-user") {
      this._gaSvc.register(`User Admin`, `Add New User Button`, user.username);
      this.modal.open(AddSupplierUserComponent)
    } else if (type === "add-customer-user") {
      this._gaSvc.register(`User Admin`, `Add New User Button`, user.username);
      this.modal.open(AddCustomerUserComponent)
    }
  }

  public navigateUpdateAffiliatedCarrier(user, orgCode){
    this._router.navigate(['../../update-carrier-user'], {
      relativeTo: this.route, queryParams: {
        ID: user._id,
        carrierID: user.organizationCode,
        affiliatedCarrier: orgCode
      }
    })
  }

  public setMobileMenuStyle() {
    // set the width of the dumb angular mat-menu in the most jank way in order to only affect the mobile version
    let overlayPane: any = document.getElementsByClassName("cdk-overlay-pane")[0]
    overlayPane.style.width = "100%";
    overlayPane.style.padding = "0 12px";
  }
}
